import { render, staticRenderFns } from "./UpdateAboutWeSip.vue?vue&type=template&id=3a435cd7"
import script from "./UpdateAboutWeSip.vue?vue&type=script&lang=js"
export * from "./UpdateAboutWeSip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports